import {Box, Chip} from "@mui/material"
import React from "react"

export const widgetChipListPrototype = [
    {
        key: "parts",
        type: "CONNECTOR",
        label: "Merkmale",
        size: 6,
        options: {
            treeName: "attributes",
            isSingleConnection: false,
        },
    },
]

const WidgetChipList = ({widget, getDataFromPointer, updateData, triggerAction}) => {
    if (!widget.parts?.length) return null

    const chips = widget.parts.filter(
        (part) => getDataFromPointer(part.origin?.pointer) === true,
    )

    if (!chips.length) return null

    const onDelete = (part) => {
        updateData(false, part.origin?.pointer)
        widget.action && triggerAction(widget.action)
    }

    return (
        <Box sx={{display: "flex", flexWrap: "wrap", gap: 1}}>
            {chips.map((part) => (
                <Chip
                    key={part.id}
                    label={part.origin?.longname}
                    onDelete={() => onDelete(part)}
                />
            ))}
        </Box>
    )
}

export default WidgetChipList
